module.exports = __webpack_public_path__ + "static/media/tlyfelogo.2b6489db.png";